import { render, staticRenderFns } from "./ManageReferenceTypes.vue?vue&type=template&id=1caf4660"
import script from "./ManageReferenceTypes.vue?vue&type=script&lang=ts"
export * from "./ManageReferenceTypes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports